// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3MdGe","errorLogs":"styles_errorLogs__PMox1"};